var classof = require('../internals/classof-raw');

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/is-array.js
// module id = 121
// module chunks = 1